export const DataDrawerOverlayAttr = {
  name: 'data-test-id',
  value: 'io-data-drawer'
};
